const sortByData = [
  { id: 1, name: "Name" },
  { id: 2, name: "Confirmed" },
  { id: 3, name: "Deaths" },
  { id: 4, name: "Recovered" },
];

export default sortByData;
